module.exports = __webpack_public_path__ + "img/flowers.29ed01f0.jpeg";